import {SET_USER} from '../actionTypes';

const initialState = {};

export default function (state = initialState, action: any) {
  switch (action.type) {
    case SET_USER: {
      const resp = Object.assign(state, action.payload);
      return JSON.parse(JSON.stringify(resp));
    }
    default:
      return state;
  }
}
